export default __webpack_public_path__ + "static/media/Refined Pharmacon of Avoidance.69e37fe2.jpg";